import { ExternalRoute, NamedRoute } from '@/router'

export default class BreadcrumbItem {
    readonly title: string
    readonly route: NamedRoute | ExternalRoute

    constructor(title: string, route?: NamedRoute | ExternalRoute) {
        this.title = title
        this.route = route
    }
}
